import React from 'react';
import type { MessageKindAdapter } from './types';
import MessageItem from '../components/MessageItem';

/** 시스템 알림 — 읽기 전용. */
const systemAdapter: MessageKindAdapter = {
 kind: 'system',
 renderMessage: (m, ctx) => (
  <MessageItem key={m.id} message={m} viewerPeerHash={ctx.viewer.peer_hash}>
   {m.body && <div className="text-sm whitespace-pre-wrap text-gray-700">{m.body}</div>}
   {Object.keys(m.payload).length > 0 && (
    <details className="text-xs text-gray-500 mt-1">
     <summary>상세</summary>
     <pre className="bg-gray-50 p-2 overflow-x-auto">{JSON.stringify(m.payload, null, 2)}</pre>
    </details>
   )}
  </MessageItem>
 ),
 renderActionPanel: () => null,
};

export default systemAdapter;
